import { REDUCER } from '../reducers/reducersConst';
import * as schoolApi from '../services/api/schoolApi';
import * as jwtService from '../services/jwt/jwtService';
import { getTokenFromStorage } from '../shared';
import { loadAndApplySkin } from './skinActions';

export let setSchoolData = (schools = []) => {
  return {
    type: REDUCER.SCHOOL.SET_SCHOOL_DATA,
    schools
  };
};

export let setSchoolInfo = (school = {}) => {
  return {
    type: REDUCER.SCHOOL.SET_SCHOOL_INFO,
    school
  };
};

export let setLoadedSchoolInfo = (loadedSchoolInfo = true) => {
  return {
    type: REDUCER.SCHOOL.SET_LOADED_SCHOOL_INFO,
    loadedSchoolInfo
  };
};

export let getSchoolInfo = () => {
  return dispatch => {
    const authToken = getTokenFromStorage();
    if (authToken) {
      const schoolId = jwtService.getSchoolId(authToken);
      const customerId = jwtService.getUserCustomerId(authToken);
      if (customerId) {
        return schoolApi
          .getSchool(schoolId, customerId)
          .then(res => {
            dispatch(setSchoolInfo(res.data));
            dispatch(loadAndApplySkin());
            return res;
          })
          .catch(e => dispatch(setLoadedSchoolInfo()));
      }
      // No se pudo obtener la información de la institución. Se da por válida la school vacía.
      dispatch(setLoadedSchoolInfo());
    }
  };
};
